/**
 * Selectable jev-web model families.
 *
 * Kept in its own import-free module so the panel can render the picker
 * without statically pulling in decider.ts (which must stay dynamically
 * imported so the model runtime stays out of the main bundle).
 */
export interface FamilyOption {
  id: string;
  label: string;
  detail: string;
}

/**
 * Selectable model families, in the order used as automatic fallbacks after
 * the user's explicit pick. Sizes are the pinned-revision downloads from the
 * jev-web README.
 */
export const FAMILIES: FamilyOption[] = [
  {
    id: 'laya',
    label: 'Laya',
    detail: 'ModernBERT + typed head · ~520 MB · 1024-token context',
  },
  {
    id: 'open-jev',
    label: 'Open-JEV',
    detail: 'Fused DeBERTa graph · ~350–480 MB · 256-token context',
  },
  {
    id: 'strands-decider',
    label: 'Strands Decider 2B',
    detail: 'Qwen torso + pointer head · ≈2 GB · 4096-token window',
  },
  {
    id: 'bekko',
    label: 'Bekko 17M',
    detail: 'Ettin cross-encoder · ~30 MB · smallest and fastest',
  },
];

export const DEFAULT_FAMILY = 'laya';
